// extracted by mini-css-extract-plugin
export default {"page":"GGKXvd","card":"Kj4u3S","subtitle":"e0FqVT","status":"fdIVnr","hint":"Yu2Tgt","error":"junwnJ","success":"HqekIq"};